var _rect, _path, _path2, _path3, _g, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCommonDoctor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 58,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.0125 56.3513C27.976 56.7647 31.7988 56.878 34.8361 56.3513C37.8734 55.8246 41 45.3924 41 45.3924C41 45.3924 39.2769 35.1473 36.8142 34.3426C34.3515 33.5378 33.0209 33.7933 29.8712 33.7173C26.7216 33.6414 24.4702 33.9264 22.9448 34.3426C21.4193 34.7587 17 46.2238 17 46.2238C17 46.2238 22.0489 55.9379 25.0125 56.3513Z",
    fill: "#828EFA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25 29.754C25 32.5921 25 33.7881 25 36.0068C25 38.2254 26.2313 40.7051 29 40.7051C31.7687 40.7051 33 39.3304 33 35.2323C33 31.1342 33 28.0091 33 28.0091C33 28.0091 25 26.9159 25 29.754Z",
    fill: "#FFE7CE"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7540_501",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 25,
    y: 27,
    width: 8,
    height: 14
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25 29.754C25 32.5921 25 33.7881 25 36.0068C25 38.2254 26.2313 40.7051 29 40.7051C31.7687 40.7051 33 39.3304 33 35.2323C33 31.1342 33 28.0091 33 28.0091C33 28.0091 25 26.9159 25 29.754Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7540_501)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.4731 30.1629C24.4193 31.7444 28.369 35.3575 33.8783 32.8368C39.3876 30.3161 30.5912 26.7051 30.5912 26.7051L23.4731 27.8376C23.4731 27.8376 22.5269 28.5814 23.4731 30.1629Z",
    fill: "#F2D0B2"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.3266 20.9601C40.173 17.8666 40.68 13.2043 39.218 10.3971C37.756 7.58991 34.0852 4.33313 31.5401 5.17674C28.9949 6.02034 33.8847 8.20215 30.5484 8.84466C27.2121 9.48717 22.1467 7.42306 18.9193 14.2543C15.6919 21.0855 22.0655 27.7798 24.1036 28.5842C26.1416 29.3885 34.4803 24.0535 37.3266 20.9601Z",
    fill: "#6157FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.1248 15.7011C39.3695 19.7016 40.2142 28.7679 34.5015 32.1576C28.7889 35.5472 23.5421 30.2843 23.126 27.2546C23.1783 26.9859 22.5905 26.6653 21.5705 26.989C20.5505 27.3126 19.0246 25.4089 18.8233 23.3433C18.622 21.2776 20.0491 20.1809 21.0445 20.5501C22.0399 20.9194 21.9363 22.9312 22.6713 23.6607C23.4062 24.3901 24.5606 24.3108 24.8344 23.314C25.1082 22.3171 22.8026 18.3772 24.567 17.1676C26.3314 15.958 27.6869 18.5112 31.6806 18.155C35.6743 17.7988 36.2996 16.1992 37.1248 15.7011Z",
    fill: "#FFE7CE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.6704 33.9995C19.5052 35.1698 13.614 36.1947 12.335 37.5744C11.0559 38.954 6.62976 45.2004 6 48.2312C9.93158 51.6618 16.7973 55.1176 26 55.7051C23.6089 51.0465 21.7028 45.9578 22.6704 40.5658C23.638 35.1738 25.8356 32.8292 22.6704 33.9995Z",
    fill: "#6157FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.3296 33.9995C39.4948 35.1698 45.386 36.1947 46.665 37.5744C47.9441 38.954 52.3702 45.2004 53 48.2312C49.0684 51.6618 42.2027 55.1176 33 55.7051C35.3911 51.0465 37.2972 45.9578 36.3296 40.5658C35.362 35.1738 33.1644 32.8292 36.3296 33.9995Z",
    fill: "#6157FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0569 43.0634C12.9289 43.8695 13.0569 43.5664 13.0569 44.3547C13.0569 45.143 13.9534 44.3547 16.2186 44.3547C18.4837 44.3547 20.0756 44.7842 19.9972 43.8014C19.9188 42.8187 20.2472 43.0634 19.2679 43.0634C18.2885 43.0634 13.1849 42.2572 13.0569 43.0634Z",
    fill: "#EDF1FC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommonDoctor);
export default __webpack_public_path__ + "static/media/common_doctor.176fe365e02a694c35d241b1a619dbd6.svg";
export { ForwardRef as ReactComponent };